<template>
  <div class="taskInfo">
    <div class="taskInfo-layout">
      <div class="info-card">
        <div class="card-title">{{ formData && formData.name }}</div>
        <van-cell-group :border="false" inset class="card-group">
          <van-cell title="项目预算" :value="displaySalaryRange()" class="cell-row budget"/>
          <van-cell title="发布企业" :value="displayMerchantName(formData.merchantName)" class="cell-row"/>
          <van-cell title="发布时间" :value="displayCreateTime()" class="cell-row"/>
          <van-cell title="经验要求" :value="formData.experienceName" class="cell-row"/>
        </van-cell-group>
      </div>

      <div class="desc-card">
        <div class="card-subtitle">项目描述</div>
        <div class="desc-body">{{ displayDescribe() }}</div>
      </div>
    </div>
    <van-button
      v-if="!isFromMyPro"
      @click="signUpProject"
      :loading="btnLoading"
      loading-text="提交中..."
      color="linear-gradient(to right, #ff6034, #ee0a24)"
      size="large"
      class="fixBtn submit-btn"
    >{{ acceptButtonText }}</van-button>
    <van-button
      v-if="!isFromTaskHome"
      @click="goUploadDeliverables"
      color="linear-gradient(to right, #ff6034, #ee0a24)"
      size="large"
      class="fixBtn deliver-btn"
    >上传交付物</van-button>
  </div>
</template>
<script>
import requestHTAPI from '@/axios/HantangTax'

export default {
  name: 'TaskInfo',
  data () {
    return {
      taskValue: 1,
      taskBorder: false,
      enGetTask: false,
      formData: {},
      btnLoading: false,
      isFromMyPro: false,
      isFromTaskHome: false,
      hasAccepted: false
    }
  },
  computed: {
    // 按钮文案：已接受则显示“已接受此任务”，否则显示“接受任务”
    acceptButtonText () {
      return this.hasAccepted ? '已接受此任务' : '接受任务'
    }
    ,
    shareUrl () {
      const id = this.$route.query.id || ''
      return `https://wechat.linkscloud.net/taskHome/taskInfo?id=${encodeURIComponent(id)}`
    }
  },
  mounted () {
    this.initPage()
  },
  methods: {
    // 显示打码后的企业名：保留前2字，尾部保留公司后缀
    displayMerchantName (name) {
      if (!name || typeof name !== 'string') return '*****公司'
      const suffixes = [
        '科技有限公司', '信息技术有限公司', '网络科技有限公司', '数据科技有限公司',
        '有限公司', '公司', '集团'
      ]
      const found = suffixes.find(s => name.endsWith(s))
      if (found) {
        const body = name.slice(0, name.length - found.length)
        const keep = body.slice(0, 2)
        return `${keep}***${found}`
      }
      // 无后缀匹配时，简单打码
      return `${name.slice(0, 2)}***`
    },
    initPage () {
      const id = this.$route.query.id
      // 判断是否从"我的项目"页面进入
      this.isFromMyPro = this.$route.query.source === 'myPro'
      // 判断是否从任务首页进入
      this.isFromTaskHome = this.$route.query.source === 'taskHome'
      this.getOneProjectById(id)
      // 初始化是否已接受状态（占位，后续接入实际方法）
      this.initAcceptanceStatus(id)
    },
    // 通过占位方法初始化项目接受状态
    async initAcceptanceStatus (projectId) {
      try {
        const accepted = await this.checkProjectAccepted(projectId)
        this.hasAccepted = Boolean(accepted)
      } catch (e) {
        // 占位方法失败时默认为未接受
        this.hasAccepted = false
      }
    },
    // 占位：检查是否已接受项目。后续将替换为你提供的真实方法。
    // 返回布尔值：true 表示已接受，false 表示未接受。
    async checkProjectAccepted (projectId) {
      // 优先从路由参数读取（便于联调/演示）：accepted=1/true 表示已接受
      const q = this.$route.query
      if (q && q.accepted !== undefined) {
        const v = String(q.accepted).toLowerCase()
        return v === '1' || v === 'true'
      }
      // 调用后端“参与次数”接口，次数 > 0 视为已接受
      try {
        const { data } = await requestHTAPI.getProjectParticipationCount({ id: projectId, projectId })
        if (data && data.code === '0000') {
          // 兼容多种返回结构：data为数字或对象包含count
          const payload = data.data
          let count = 0
          if (typeof payload === 'number') {
            count = payload
          } else if (payload && typeof payload.count === 'number') {
            count = payload.count
          } else if (payload !== undefined && payload !== null) {
            const n = Number(payload)
            count = isNaN(n) ? 0 : n
          }
          return Number(count) > 0
        }
      } catch (e) {
        // 忽略错误，按未接受处理
      }
      return false
    },
    async getOneProjectById (id) {
      const { data } = await requestHTAPI.getOneProjectById({
        id
      })
      if (data.code === '0000') {
        this.formData = data.data || {}
        if (data.data && Object.keys(data.data).length === 0) {
          // 获取URL中的merNo参数
          const merNo = this.$route.query.merNo
          if (merNo) {
            // 跳转到指定页面，携带merNo参数
            this.$router.push(`/mine/userInfo?content=${merNo}`)
          }
        }
      } else {
        this.$notify({ type: 'danger', message: data.message })
      }
    },
    displaySalaryRange () {
      const val = this.formData && this.formData.salaryRange
      if (val !== undefined && val !== null && String(val).trim()) return `${String(val).trim()}元`
      return '暂无'
    },
    displayCreateTime () {
      const val = this.formData && this.formData.createTime
      if (val && String(val).trim()) return val
      return '--'
    },
    displayDescribe () {
      const val = this.formData && this.formData.describe
      if (val && String(val).trim()) return String(val).trim()
      return '暂无项目描述'
    },
    async signUpProject () {
      // 若已接受：打卡商户进打卡页，普通商户进交付页
      if (this.hasAccepted) {
        const checkInEnabled = await this.isCheckInMerchant()
        this.$router.push(checkInEnabled ? '/checkIn' : '/mine/uploadDeliverables')
        return
      }
      // 接受任务前校验是否已获取到用户信息，未获取则跳转到个人信息页
      const ready = await this.ensureUserInfoReady()
      if (!ready) return
      this.btnLoading = true
      requestHTAPI.signUpProject({
        id: this.formData.id,
        merchantId: this.formData.merchantId
      }).then(async res => {
        this.btnLoading = false
        if (res.data.code === '0000') {
          this.hasAccepted = true
          const checkInEnabled = await this.isCheckInMerchant()
          if (checkInEnabled) {
            this.$toast.success('接受成功，请完成拍照打卡')
            this.$router.push('/checkIn')
          } else {
            this.$notify({ type: 'success', message: '操作成功' })
          }
        } else {
          const msg = (res.data && res.data.message) ? String(res.data.message) : ''
          if (msg.includes('您已经参与过该项目')) {
            this.hasAccepted = true
            const checkInEnabled = await this.isCheckInMerchant()
            this.$router.push(checkInEnabled ? '/checkIn' : '/mine/uploadDeliverables')
          } else {
            this.$notify({ type: 'danger', message: res.data.message })
          }
        }
      }).catch(() => {
        this.btnLoading = false
      })
    },
    // 是否开通打卡的特殊商户
    async isCheckInMerchant () {
      try {
        const merNo = localStorage.getItem('MERNO') || ''
        if (!merNo) return false
        const res = await requestHTAPI.checkInStatus({ merNo })
        return !!(res && res.data && res.data.code === '0000' && res.data.data && res.data.data.enabled)
      } catch (e) {
        return false
      }
    }
    ,
    // 校验用户信息是否已获取，未获取则跳转到“个人信息”页
    async ensureUserInfoReady () {
      try {
        const merNo = localStorage.getItem('MERNO')
        if (!merNo) {
          // 未获取商户ID时提示并跳转到个人信息页
          this.$toast('未获取商户ID，请先注册个人信息')
          this.$router.push('/mine/userInfo')
          return false
        }
        const fd = new FormData()
        fd.append('merId', merNo)
        const res = await requestHTAPI.mineInfo(fd)
        if (res && res.data && res.data.code === '0000') {
          const data = res.data.data || {}
          // 若接口未返回用户ID，视为未完善信息
          if (!data.id) {
            this.$toast('未完善个人信息，请先注册个人信息')
            this.$router.push('/mine/userInfo')
            return false
          }
          return true
        }
        this.$toast('获取用户信息失败，请先注册个人信息')
        this.$router.push('/mine/userInfo')
        return false
      } catch (e) {
        this.$toast('获取用户信息异常，请先注册个人信息')
        this.$router.push('/mine/userInfo')
        return false
      }
    },
    goUploadDeliverables () {
      this.$router.push('/mine/uploadDeliverables')
    },
    async copyShareLink () {
      const text = this.shareUrl
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text)
        } else {
          const input = document.createElement('input')
          input.value = text
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
        }
        this.$toast('已复制分享链接')
      } catch (e) {
        this.$toast('复制失败，请手动复制')
      }
    }
  }
}
</script>
<style scoped lang="less">
  .taskInfo {
    background: #f6f8fc;
  }

  .taskInfo-layout {
    text-align: left;
    padding-top: 24px;
    background: #fff;
    padding-bottom: 120px;

    &.no-button {
      padding-bottom: 40px;
    }
  }

  .fixBtn {
    position: fixed;
    left: 0;
    bottom: 0;
  }
  .submit-btn{
    width: calc(100% - 32px);
    margin: 16px;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(238, 10, 36, 0.3);
  }
  .deliver-btn{
    width: calc(100% - 32px);
    margin: 16px;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(238, 10, 36, 0.3);
    bottom: 68px;
  }
  .info-card, .desc-card{
    background: #fff;
    margin: 12px 16px;
    border-radius: 14px;
    box-shadow: 0 6px 16px rgba(0,0,0,0.06);
    padding: 14px 16px;
  }
  .info-card{ position: relative; }
  .share-icon-wrap{
    position: absolute;
    right: 16px;
    top: 16px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .share-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .card-title{
    font-size: 20px;
    font-weight: 600;
    color: #1f2d3d;
    margin-bottom: 10px;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .card-subtitle{
    font-size: 16px;
    font-weight: 600;
    color: #162336;
    margin-bottom: 12px;
  }
  .card-group .van-cell{
    padding: 16px 0;
  }
  .card-group .van-cell:not(:last-child)::after{
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: #f0f0f0;
  }
  .card-group .van-cell__title{
    color: #6b7280;
    text-align: left;
    line-height: 1.9;
  }
  .card-group .van-cell__value{
    color: #1f2d3d;
    text-align: left;
    line-height: 1.9;
  }
  .card-group .budget .van-cell__value{
    color: #ff4d4f;
  }
  .desc-body{
    font-size: 15px;
    color: #333;
    line-height: 1.9;
    white-space: pre-wrap;
    text-align: left;
  }
</style>
